import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'pcg-delete-comment-modal'
    , templateUrl: './delete-comment-modal.component.html'
    , standalone: false
})
export class DeleteCommentModalComponent implements AfterViewInit {
    
	@Input() deleteComment: string = '';    
	@Output() onConfirm = new EventEmitter<string>(); 
	@ViewChild('deleteCommentInput') deleteCommentInput!: ElementRef<HTMLTextAreaElement>;

	noDeleteMessage = false;

	constructor(public activeModal: NgbActiveModal) {}

	confirmDelete() {
		if (this.deleteComment?.trim().length === 0) {
			this.noDeleteMessage = true;
			return;
		}

		this.activeModal.close(this.deleteComment);
	}

	cancel() { this.activeModal.dismiss(); }
	ngAfterViewInit() { this.deleteCommentInput.nativeElement.focus(); }
}
